export default __webpack_public_path__ + "static/media/gbp-flag.e9f7c46f.svg";